import postAPI from './postAPI.js'

export default async function postGetLinkableFields(body) {
    const data = await postAPI('admin/taskinstances/linkablefields', body);
    return data;
}
